import styled from 'styled-components';

export const Container = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
`

export const ContainerBody = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    flex-direction: column;
`

export const Row = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
`

// lista de checkboxes com a aparência de um único campo (mesma borda dos inputs)
export const CheckListField = styled.div`
    width: 100%;
    margin-bottom: 10px;

    & > label {
        margin: 0px;
        color: #74777A;
    }
`

export const CheckList = styled.div`
    height: auto;
    padding: 4px 12px;
`

// a linha inteira é o label: clicar em qualquer ponto dela alterna o checkbox
export const CheckListItem = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 4px 0px;
    margin: 0px;
    cursor: pointer;
    user-select: none;

    & input {
        margin: 0px;
        cursor: pointer;
    }
`